import { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { purchaseCredits } from '../../services/api';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { LoadingSpinner } from '../ui/LoadingSpinner';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '');

const CREDIT_PACKAGES = [
  { id: '1', credits: 1, price: 2.90, priceFormatted: 'R$ 2,90' },
  { id: '5', credits: 5, price: 12.90, priceFormatted: 'R$ 12,90' },
  { id: '10', credits: 10, price: 24.90, priceFormatted: 'R$ 24,90' },
  { id: '20', credits: 20, price: 44.90, priceFormatted: 'R$ 44,90' }
];

export const CreditPurchase = () => {
  const [loading, setLoading] = useState<string | null>(null);

  const handlePurchase = async (packageId: string) => {
    try {
      setLoading(packageId);
      const { url } = await purchaseCredits({ package_id: packageId });
      
      const stripe = await stripePromise;
      if (stripe && url) {
        window.location.href = url;
      }
    } catch (error: any) {
      console.error('Purchase error:', error);
      alert('Erro ao processar compra. Tente novamente.');
    } finally {
      setLoading(null);
    }
  };

  return (
    <div>
      <h2 className="text-3xl font-bold mb-2">Comprar Créditos</h2>
      <p className="text-gray-400 mb-8">
        Escolha um pacote de créditos para continuar analisando vídeos
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {CREDIT_PACKAGES.map((pkg) => (
          <Card key={pkg.id} className="p-6 text-center" hover>
            <div className="mb-4">
              <div className="text-3xl font-bold gradient-text mb-2">
                {pkg.credits}
              </div>
              <div className="text-sm text-gray-400">crédito{pkg.credits > 1 ? 's' : ''}</div>
            </div>
            <div className="text-2xl font-bold text-white mb-6">
              {pkg.priceFormatted}
            </div>
            <Button
              className="w-full"
              onClick={() => handlePurchase(pkg.id)}
              disabled={loading === pkg.id}
            >
              {loading === pkg.id ? (
                <LoadingSpinner size="sm" />
              ) : (
                'Comprar'
              )}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
};

